module.exports = __webpack_public_path__ + "img/newuse-bg-mobile.3f6b30bb.png";